import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirTvDisplay() {
  return {
    publicUrl: '',
    saving: false,
    uploading: false,
    sliderFile: null,
    sliderPosition: 'top_right',
    form: {
      tv_url: '',
      running_text: '',
      is_active: true,
      sound_enabled: true,
      refresh_seconds: 60,
      video_name: null,
      video_file: null,
      video_url: '',
    },
    sliders: {
      top_right: [],
      bottom_left: [],
    },

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.applyConfig(cfg);
      } catch (e) {
        console.error('kasirTvDisplay config', e);
      }
    },

    applyConfig(cfg) {
      this.publicUrl = cfg.public_url || '/tv_display';
      const s = cfg.settings || {};
      this.form.tv_url = s.tv_url || '';
      this.form.running_text = s.running_text || '';
      this.form.is_active = s.is_active !== false;
      this.form.sound_enabled = s.sound_enabled !== false;
      this.form.refresh_seconds = s.refresh_seconds || 60;
      this.form.video_name = s.video_name || null;
      this.form.video_file = null;
      this.form.video_url = s.video_source_url || '';
      this.sliders = {
        top_right: cfg.sliders?.top_right || [],
        bottom_left: cfg.sliders?.bottom_left || [],
      };
    },

    onVideoPicked(e) {
      this.form.video_file = e.target.files?.[0] || null;
      if (this.form.video_file) {
        this.form.video_name = this.form.video_file.name;
        this.form.video_url = '';
      }
    },

    async saveSettings() {
      this.saving = true;
      try {
        const fd = new FormData();
        fd.append('tv_url', this.form.tv_url || '');
        fd.append('running_text', this.form.running_text || '');
        fd.append('is_active', this.form.is_active ? '1' : '0');
        fd.append('sound_enabled', this.form.sound_enabled ? '1' : '0');
        fd.append('refresh_seconds', String(this.form.refresh_seconds || 60));
        if (this.form.video_file) {
          fd.append('video_file', this.form.video_file);
        } else if ((this.form.video_url || '').trim()) {
          fd.append('video_url', this.form.video_url.trim());
        }
        const { data } = await axios.post('/api/v1/kasir/tv-display', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        this.applyConfig(data.data || {});
        window.toast?.(data.message || 'Pengaturan disimpan.', 'success');
      } catch (e) {
        window.toast?.(e?.response?.data?.message || 'Gagal menyimpan.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async uploadSlider() {
      if (!this.sliderFile) {
        window.toast?.('Pilih file gambar dulu.', 'error');
        return;
      }
      this.uploading = true;
      try {
        const fd = new FormData();
        fd.append('position', this.sliderPosition);
        fd.append('file_image', this.sliderFile);
        const { data } = await axios.post('/api/v1/kasir/tv-display/sliders', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        const img = data.data;
        if (img?.position === 'bottom_left') {
          this.sliders.bottom_left.push(img);
        } else {
          this.sliders.top_right.push(img);
        }
        this.sliderFile = null;
        window.toast?.(data.message || 'Gambar ditambahkan.', 'success');
      } catch (e) {
        window.toast?.(e?.response?.data?.message || 'Gagal upload.', 'error');
      } finally {
        this.uploading = false;
      }
    },

    async removeSlider(img) {
      if (!window.confirm('Hapus gambar ini?')) return;
      try {
        await axios.delete(`/api/v1/kasir/tv-display/sliders/${img.id}`);
        this.sliders.top_right = this.sliders.top_right.filter((i) => i.id !== img.id);
        this.sliders.bottom_left = this.sliders.bottom_left.filter((i) => i.id !== img.id);
        window.toast?.('Gambar dihapus.', 'success');
      } catch (e) {
        window.toast?.(e?.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },
  };
}

Alpine.data('kasirTvDisplay', createKasirTvDisplay);
